import React from 'react';
import * as Typography from '@/components/shadcn/typography';
import { ContentSection } from '@/constants/tos';

interface Props {
  data: {
    title: string;
    date: string;
    sections: ContentSection[];
  };
  sections: ContentSection[];
}

const Content = ({ data, sections }: Props) => {
  return (
    <div className="flex flex-col gap-4 pb-10">
      <div className="pb-1 text-neutral-400">
        <p>Last Updated: {data.date}</p>
      </div>
      <Typography.H5>{data.title}</Typography.H5>
      <div className="flex flex-col gap-4">
        {sections.map(section => (
          <div key={section.title} className="flex flex-col gap-4">
            <Typography.H6>{section.title}</Typography.H6>
            {section.list && <Typography.List list={section.list} />}
            {section.content?.map(content => (
              <p
                dangerouslySetInnerHTML={{ __html: content }}
                key={content}
                className="[&>a]:text-azure-500"
              />
            ))}
            {section.nestedItems?.map(nestedItem => (
              <div className="flex flex-col gap-4 py-3" key={nestedItem.title}>
                <Typography.H6>{nestedItem.title}</Typography.H6>
                {nestedItem.description && (
                  <Typography.P>{nestedItem.description}</Typography.P>
                )}
                {nestedItem.list && <Typography.List list={nestedItem.list} />}
                {nestedItem.content?.map((content, index) => (
                  <p
                    key={index.toString()}
                    dangerouslySetInnerHTML={{ __html: content }}
                    className="[&>a]:text-azure-500"
                  />
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Content;
